"use client";

import { c as _c } from "react/compiler-runtime";
import { Primitive } from "@radix-ui/react-primitive";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@/lib/utils";
import { createContext, useContext } from "react";
const ControlGroupContext = createContext<Pick<ControlGroupProps, "orientation">>({
  orientation: "horizontal"
});
function useControlGroup() {
  return useContext(ControlGroupContext);
}
export interface ControlGroupProps extends React.ComponentProps<typeof Primitive.div> {
  orientation?: "horizontal" | "vertical";
}
function ControlGroup(t0) {
  const $ = _c(16);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      orientation: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const orientation = t1 === undefined ? "horizontal" : t1;
  let t2;
  if ($[4] !== orientation) {
    t2 = {
      orientation
    };
    $[4] = orientation;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = orientation === "vertical" && "flex-col";
  let t4;
  if ($[6] !== className || $[7] !== t3) {
    t4 = cn("flex", t3, className);
    $[6] = className;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== orientation || $[10] !== props || $[11] !== t4) {
    t5 = <Primitive.div data-slot="control-group" data-orientation={orientation} className={t4} {...props} />;
    $[9] = orientation;
    $[10] = props;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t2 || $[14] !== t5) {
    t6 = <ControlGroupContext.Provider value={t2}>{t5}</ControlGroupContext.Provider>;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
function ControlGroupItem(t0) {
  const $ = _c(10);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const {
    orientation
  } = useControlGroup();
  const t1 = orientation === "horizontal" && "-me-px h-auto first:rounded-s-md last:me-0 last:rounded-e-md";
  const t2 = orientation === "vertical" && "-mbe-px w-auto first:rounded-ss-md first:rounded-se-md last:mbe-0 last:rounded-ee-md last:rounded-es-md";
  let t3;
  if ($[3] !== className || $[4] !== t1 || $[5] !== t2) {
    t3 = cn("rounded-none focus-within:z-10", t1, t2, className);
    $[3] = className;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props || $[8] !== t3) {
    t4 = <Slot data-slot="control-group-item" className={t3} {...props} />;
    $[7] = props;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export { ControlGroup, ControlGroupItem };